import applyFilters from "./helpers/applyFilters";
import Story from "models/Story";

const initialState = {
  isFetching: false,
  stock: [],
  items: [],
  outletItems: [],
  newItems: [],
  allItems: [],
  promotionCode: null,
  stories: [],
  parameters: {},
  filters: {
    year: null,
    price: {
      min: null,
      max: null,
    },
    km: {
      min: null,
      max: null,
    },
    brand: null,
    color: null,
    engine: null,
    body: null,
  },
};

export default function stock(state = initialState, action) {
  switch (action.type) {
    case "FETCH_STOCK":
      return state;
    case "REQUEST_STOCK":
      return Object.assign({}, state, {
        isFetching: true,
      });
    case "REQUEST_STOCK_FAILED":
      return Object.assign({}, state, {
        isFetching: false,
        stock: [],
      });
    case "RECEIVE_STOCK": {
      const vehicles = applyFilters(action.items, state.filters);
      const selectedVehicles = vehicles.filter((vehicle) => vehicle.type === "3");
      const newVehicles = vehicles.filter((vehicle) => vehicle.type === "2");
      const outletVehicles = vehicles.filter((vehicle) => vehicle.type === "1");

      return Object.assign({}, state, {
        isFetching: false,
        stock: action.items,
        items: selectedVehicles,
        outletItems: outletVehicles,
        newItems: newVehicles,
        allItems: action.items,
      });
    }
    case "RECEIVE_STORIES":
      return {
        ...state,
        stories: action.items.map((data) => new Story(data)),
      };
    case "RECEIVE_PROMOTION_CODES": {
      return {
        ...state,
        promotionCode: action.payload,
      };
    }
    case "RECEIVE_PARAMETERS":
      return {
        ...state,
        parameters: action.payload,
      };

    case "FILTER_STOCK": {
      const newFilters = Object.assign({}, state.filters, {
        [action.filter]: action.value,
      });

      const vehicles = applyFilters(state.stock, newFilters);
      const selectedVehicles = vehicles.filter((vehicle) => vehicle.type === "3");
      const newVehicles = vehicles.filter((vehicle) => vehicle.type === "2");
      const outletVehicles = vehicles.filter((vehicle) => vehicle.type === "1");

      return Object.assign({}, state, {
        filters: newFilters,
        items: selectedVehicles,
        newItems: newVehicles,
        outletItems: outletVehicles,
      });
    }

    case "REQUEST_STOCK_ITEM":
      return Object.assign({}, state, {
        isFetching: true,
        item: undefined,
      });
    case "REQUEST_STOCK_ITEM_FAILED":
      return Object.assign({}, state, {
        isFetching: false,
        item: null,
      });
    case "RECEIVE_STOCK_ITEM":
      return Object.assign({}, state, {
        isFetching: false,
        item: action.item,
      });

    default:
      return state;
  }
}
